import { type Comment as CommentType } from '@/@types/comment'
import type { ReactNode } from 'react'
import AuthorTag from '../AuthorTag'
import ScreenName from '../ScreenName'
import styles from './CommentHeaderTitle.module.css'

export interface CommentHeaderTitleProps {
	actions?: ReactNode
	data: CommentType
	isPostAuthor?: boolean
	noSuffixTitle?: boolean
}

export default function CommentHeaderTitle({
	actions,
	data,
	isPostAuthor = false,
	noSuffixTitle = false,
}: CommentHeaderTitleProps) {
	const { replyToComment, user } = data
	const hasReply = !!(!noSuffixTitle && replyToComment)
	const screenNameContainerProps = {
		targetProps: { className: styles.screenNameTarget },
	}

	return (
		<div className={styles.root}>
			<div className={styles.content}>
				<ScreenName
					data={data.user}
					className={styles.screenName}
					containerProps={screenNameContainerProps}
				/>
				{isPostAuthor && <AuthorTag />}
				{hasReply && (
					<div className={styles.replyContainer}>
						<span className={styles.replyLabel}>回复</span>
						<ScreenName
							data={replyToComment.user}
							className={styles.screenName}
							containerProps={screenNameContainerProps}
						/>
					</div>
				)}
			</div>
			{actions && <div className={styles.actions}>{actions}</div>}
		</div>
	)
}
